/**
 * Created by piotr.pozniak@thebeaverhead.com on 07/02/2025
 */

import React from "react";
import { useUserStore } from "../../../../hooks/redux/user";
import Icon from "../../theme/untitled/icons/Icon";
import "./CompleteWPConnection.css";

const CompleteWPConnection = () => {
  const {
    user: { pluginRedirectUrl },
  } = useUserStore();

  // Setup complete — the component renders null. There is no success
  // variant; the alert's absence is the success state.
  if (!pluginRedirectUrl) {
    return null;
  }

  // read site name value from redirectUrl
  const siteName = pluginRedirectUrl.split("sitename=")[1].split("&")[0];

  return (
    <div className="wpc-banner" role="status">
      <Icon name="AlertCircle" size={20} className="wpc-icon" />
      <div className="wpc-content">
        <b className="wpc-title">Finish connecting your WordPress site</b>
        <p className="wpc-body">
          You&rsquo;ll be redirected to confirm the link for{" "}
          <b>{siteName}</b>, then returned to your WordPress dashboard. Your
          events won&rsquo;t appear on the site until this is done.
        </p>
        <div className="wpc-action">
          <a href={pluginRedirectUrl} target={"_finishWPSetup"}>
            Complete setup
          </a>
        </div>
      </div>
    </div>
  );
};

export default CompleteWPConnection;
